import React from 'react';
import { Row, Col } from 'reactstrap';
import OrderDetailShippingCard from '../../components/admin/OrderDetailShippingCard';
import OrderDetailSummaryCard from '../../components/admin/OrderDetailSummaryCard';
import OrderShipmentTracking from '../../components/admin/OrderShipmentTracking';
import { MOCK_SHIPMENT_ORDER_NOT_SHIPPED } from '../../helper/shipment_tracking_helper';
import { formatCurrency } from '../../helper/order_helper';
import { formatOrderItemSku } from '../../helper/order_item_helper';
import {
  getOrderItemMrp,
  getOrderItemUnitPrice,
  itemShowsMrpStrike,
} from '../../helper/order_summary_helper';
import { getOrderItemName, PRODUCT_IMAGE_PLACEHOLDER } from '../../components/OrderItemsCell';

const MOCK_ORDER = {
  ...MOCK_SHIPMENT_ORDER_NOT_SHIPPED,
  orderNumber: 'ORD1792519323251721',
  status: 'Shipped',
  paymentMethod: 'COD',
  paymentStatus: 'Pending',
  shippingAddress: {
    firstName: 'Suchitra',
    lastName: 'C',
    street: 'Sample Street, Locality',
    city: 'Hyderabad',
    state: 'Telangana',
    zipcode: '500081',
    country: 'India',
    email: 'suchitrac62@gmail.com',
    phone: '6302647943',
  },
  items: [
    {
      name: '2% Kojic Acid Face Serum',
      sku: null,
      size: '20ml',
      quantity: 1,
      mrp: 899,
      price: 699,
      discount: 200,
    },
  ],
  subtotal: 699,
  totalDiscount: 200,
  shippingFee: 0,
  total: 699,
};

export default function OrderDetailPreview() {
  const item = MOCK_ORDER.items[0];

  return (
    <div className="main main-app p-3 p-lg-4">
      <div className="card card-one border shadow-sm p-3 p-md-4" style={{ maxWidth: 1100, margin: '0 auto' }}>
        <h5 className="mb-3">Order Details — {MOCK_ORDER.orderNumber}</h5>
        <OrderShipmentTracking order={MOCK_ORDER} />
        <Row>
          <Col md={6}>
            <h6 className="mb-3 fw-bold">Order Items (1)</h6>
            <div className="order-item-row d-flex gap-2 mb-3">
              <img src={PRODUCT_IMAGE_PLACEHOLDER} alt="" className="order-item-thumb" />
              <div>
                <p className="order-item-name fw-semibold mb-1">{getOrderItemName(item)}</p>
                <p className="order-item-meta small text-muted mb-1">
                  SKU: <strong>{formatOrderItemSku(item)}</strong> · Size: {item.size} · Qty: {item.quantity}
                </p>
                <p className="order-item-meta mb-0">
                  <strong>{formatCurrency(getOrderItemUnitPrice(item))}</strong>
                  <span className="text-muted">
                    {' '}
                    (
                    {itemShowsMrpStrike(item) ? (
                      <span className="text-decoration-line-through me-1">
                        {formatCurrency(getOrderItemMrp(item))}
                      </span>
                    ) : null}
                    {formatCurrency(getOrderItemUnitPrice(item))} each)
                  </span>
                </p>
              </div>
            </div>
          </Col>
          <Col md={6}>
            <OrderDetailShippingCard shippingAddress={MOCK_ORDER.shippingAddress} />
            <OrderDetailSummaryCard order={MOCK_ORDER} />
          </Col>
        </Row>
      </div>
    </div>
  );
}
